module.exports = __webpack_public_path__ + "img/25t.e6ef1944.jpg";